export default __webpack_public_path__ + "static/media/twitter.4c96f472.svg";